import styled from 'styled-components';
import { caption, spacing } from 'ui/theme';

type VariantPillWrapperProps = {
  bgColor: string;
  textColor: string;
};

export const VariantPillWrapper = styled.div<VariantPillWrapperProps>`
  ${caption}
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  width: ${spacing.plusQuarter};
  height: ${spacing.plusQuarter};
  padding: ${spacing.eighth} 0;
  border-radius: ${spacing.quarter};
  background-color: ${({ bgColor }) => bgColor};
  color: ${({ textColor }) => textColor};
`;
